import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CloudSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.05568 18.1987H17.0292C19.8261 18.1987 22 16.085 22 13.379C22 10.6342 19.7478 8.59474 16.7639 8.60545C15.6563 6.37507 13.6334 5 11.0968 5C7.83928 5 5.12739 7.57398 4.85214 10.8673C3.18403 11.3329 2 12.7343 2 14.518C2 16.6558 3.58913 18.1987 6.05568 18.1987Z"
        fill={color}
      />
    </svg>
  );
};

export { CloudSvg };
